export default "__VITE_ASSET__CXTCLet1__"